import clsx from 'clsx';
import React from 'react';

export default ({ className, dataAtid = '' }) => (
    <svg className={clsx('icon chevron-down-icon', className)} viewBox="0 0 13 6" data-atid={dataAtid}>
        <path d="M11.95.14a.64.64 0 01.913.117c.22.291.17.71-.114.936L6.899 5.86a.637.637 0 01-.798 0L.25 1.193A.678.678 0 01.137.257.64.64 0 011.049.14L6.5 4.49 11.95.14z" />
    </svg>
);
